import { useEffect } from "react";
import { useMarketplaceFetcher } from "../../../product/marketplaceLoader.ts";

export default function useMarketplaceOptions(sku: string, vbid?: string) {
  const fetcher = useMarketplaceFetcher();
  // marketplace options can be called from different routes, in that case a vbid is needed
  const href = `${vbid ? `products/${vbid}/` : ""}marketplace/${sku}`;

  useEffect(() => {
    if (fetcher.state === "idle" && !fetcher.data) {
      fetcher.load(href);
    }
  }, [fetcher, href]);

  return fetcher;
}
